import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { IEditDTO  } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseGetSetpointParams = {
    groupID: number,
    setpointID: number | undefined,
    organizationID: number,
} & BaseUseQueryParameters<IEditDTO | undefined>;

export function useGetSetpoint({
    groupID,
    organizationID,
    setpointID,
    enabled,    
    onSuccess,
    onError
}: UseGetSetpointParams) {
    return useQuery<IEditDTO, RestError>(
        keys.getSetpoint(groupID, setpointID, organizationID),
        ({ signal }) => {
            return SetpointAdministrationDataService.getSetpoint(
                groupID,
                organizationID,
                setpointID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}